var Searches = function () {
    var councilDisplayName;
    var useDefaultSearchPeriod = true; // default is next 30 days, WhenIndex:All
    var isTaggedEventsPage = false;
    var eventTypeMap = {
        0: 'All',
        1: 'CommunityDiary',
        2: 'Training',
        3: 'Inter_Agency',
        4: 'Clubs_Group',
        5: 'Outreach_Service',
        7: 'Queensland_Mental_Health_Week'
    };
    var eventFormatMap = {
        0: 'All',
        1: 'Class',
        2: 'Exhibition',
        3: 'Festival',
        4: 'Market',
        5: 'Concert',
        6: 'Sport',
        7: 'Business',
        8: 'Community',
        9: 'Food',
        10: 'Vaks',
        11: 'Health',
        12: 'TransportHub',
        13: 'CovidVaccinationClinic',
        14: 'CovidTestingClinic'
    };

    var DiaryFormatsDisplayName = {
        1: "Classes, Lessons, Workshops and Talks",
        2: "Exhibition and Shows",
        3: "Festivals and Celebrations",
        4: "Markets",
        5: "Concert or Performance",
        6: "Sporting Events",
        7: "Business Event",
        8: "Community Event",
        9: "Food and Wine",
        10: "VAKS",
        11: "Health",
        12: "Transport Hub",
        13: "COVID Vaccination Clinic",
        14: "COVID Testing Clinic"
    }

    function truncateString(str, len) {
        if (str.length <= len) {
            return;
        }
        return str.substring(0, len - 4) + ' ...';
    }
    function populateSearch(data) {
        if (data === null || typeof data !== "object") return;

        if (data.What) $("#SearchCriteria_WhatText").val(data.What);
        if (data.Where) $("#SearchCriteria_WhereText").val(data.Where);
        if (data.LocationID) $("#SearchCriteria_LocationID").val(data.LocationID);
        if (data.What) $("#SearchCriteria_WhatText").val(data.What);
        if (data.WhenIndex) $("#WhenIndex").val(data.WhenIndex);
        if (data.SearchFrom) $("#SearchFrom").val(data.SearchFrom);
        if (data.SearchTo) $("#SearchTo").val(data.SearchTo);
        if (data.ViewableBy) $("#SearchCriteria_ViewableBy").val(data.ViewableBy);
        if (data.DiaryTypeID) $("#DiaryType").val(data.DiaryTypeID);
        if (data.KeyWords) $("#KeyWords").val(data.KeyWords);
        if (data.DiaryAudienceID) $("#DiaryAudience").val(data.DiaryAudienceID);
        if (data.DiaryFormatID) $("#DiaryFormat").val(data.DiaryFormatID);
        if (data.LocationOutletID) $("#SearchCriteria_LocationOutletID").val(data.LocationOutletID);
        if (data.ManagedOutletID) $("#SearchCriteria_ManagedOutletID").val(data.ManagedOutletID);
    }

    function buildSearch(uniqueEvents) {
        var search = {};
        search.IgnoreEventIds = ignoreEventIds;
        search.IgnoreEventKeys = ignoreEventKeys;
        search.WhatText = $("#SearchCriteria_WhatText").val();
        //search.WhereText = $("#SearchCriteria_WhereText").val();
        search.LocationID = $("#SearchCriteria_LocationID").val();
        searchDefaults.Latitude = $("#SearchCriteria_Latitude").val();
        searchDefaults.Longitude = $("#SearchCriteria_Longitude").val();
        searchDefaults.GeographyID = $('#SessionGeographyId').val();

        if (searchDefaults.CalendarDisplay) {
            search.WhenIndex = "5";
        }
        else {
            if ($("#WhenIndex").length > 0) {
                search.WhenIndex = $("#WhenIndex").val();
            } else {
                search.WhenIndex = "All";
            }
            if ($("#SearchFrom").length > 0 && $("#SearchTo").length > 0) {
                search.SearchFrom = createDateTime($("#SearchFrom").val(), 0, 0, 0, 0);
                search.SearchTo = createDateTime($("#SearchTo").val(), 23, 59, 59, 999);
            } else {
                var today = new Date();
                // Get the day, month, and year
                var day = String(today.getDate()).padStart(2, '0'); // Day of the month (ensure 2 digits)
                var month = String(today.getMonth() + 1).padStart(2, '0'); // Month (0-11), add 1 to make it 1-12, ensure 2 digits
                var year = today.getFullYear(); // Full year (e.g., 2024)
                // Format in d/MM/yyyy format
                var formattedDate = day + '/' + month + '/' + year;
                search.SearchFrom = createDateTime(formattedDate, 0, 0, 0, 0);
                search.SearchTo = "";
            }
            search.PageNo = searchDefaults.PageNo;
            search.PageSize = searchDefaults.PageSize;
        }

        search.DiaryTypeID = $("#DiaryType").val();
        search.CouncilID = searchDefaults.CouncilID;
        search.StateCode = searchDefaults.StateCode;

        if (searchDefaults.DiaryCategories) search.DiaryCategories = searchDefaults.DiaryCategories;

        search.KeyWords = $("#KeyWords").val();
        search.DiaryAudienceID = $("#DiaryAudience").val();
        search.DiaryFormatID = $("#DiaryFormat").val();
        search.UniqueEvents = uniqueEvents;
        search.IncludeDeletedAndUnpublished = false;

        if (searchDefaults.AffiliateSiteID) search.AffiliateSiteID = searchDefaults.AffiliateSiteID;

        search.ViewableBy = $("#SearchCriteria_ViewableBy").val() !== "" ? $("#SearchCriteria_ViewableBy").val() : "0";

        if (searchDefaults.GeographyID) search.GeographyID = searchDefaults.GeographyID;
        if (searchDefaults.CustomTagID) search.CustomTagID = searchDefaults.CustomTagID;
        if (searchDefaults.SearchOrganisationID) search.SearchOrganisationID = searchDefaults.SearchOrganisationID;
        if (searchDefaults.LocationOutletID) search.LocationOutletID = searchDefaults.LocationOutletID;

        if (searchDefaults.Latitude && searchDefaults.Longitude) {
            search.Latitude = searchDefaults.Latitude;
            search.Longitude = searchDefaults.Longitude;
            search.RadiusKM = 5;
        }
       
        if (searchDefaults.ManagedOutletID) search.ManagedOutletID = searchDefaults.ManagedOutletID;
        return search;
    }

    function createDateTime(dateVal, hour, min, sec, ms) {
        var parts = dateVal.split(" ");
        if (0 === parts.length || "" === parts[0]) {
            return "";
        }
        parts = parts[0].split("/");
        if (parts.length >= 3) {
            return new Date(parts[2], parts[1] - 1, parts[0], hour, min, sec, ms).toISOString();
        }
        return "";
    }

    function showLoading() {
        searchDefaults.ScrollLoading = true;
        $("#resultsPanel .waiting").show();
        aria.Utils.AriaAlert("Getting results...");
    }

    function hideLoading() {
        $("#resultsPanel .waiting").hide();
        searchDefaults.ScrollLoading = false;
        aria.Utils.AriaAlert("Showing results...");
    }

    // Switching to different DiaryType or DiaryFormat must clear ignoreEventIds, ignoreEventKeys
    var ignoreEventIds = [0];
    var ignoreEventKeys = [''];

    function GetGeographyResults(options, _searchOptions) {
        var opts = options || {};
        var currentDate = opts.currentDate || null;
        var PAGE_NO = opts.PAGE_NO || 1;
        var MAX_PAGE_SIZE = opts.MAX_PAGE_SIZE || 20;
        var PAGE_CONTENT_SIZE = opts.PAGE_CONTENT_SIZE || 20;
        var geographyId = opts.geographyId || null;

        var searchOptions = _searchOptions || {};
        var diaryTypeIDs = searchOptions.DiaryTypeIDs || [1, 4, 5];
        var diaryFormatID = searchOptions.DiaryFormatID || 0;
        var whenIndex = searchOptions.WhenIndex || 'All';
        var searchTo = searchOptions.SearchTo || "";

        if (!geographyId || $('#SearchCriteria_WhereText').val() == "") return;

        if (!currentDate) {
            var date = new Date();
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            currentDate = year + '-' + month + '-' + day;
        }

        $.ajax({
            type: "GET",
            url: window.AppSettings.ApiUrl + '/api/v1/search/diary/GetResponse',
            data: {
                WhenIndex: whenIndex,
                SearchFrom: currentDate,
                SearchTo: searchTo,
                PageNo: PAGE_NO,
                PageSize: MAX_PAGE_SIZE, // Page Size for calculating total pages
                UniqueEvents: true,
                IncludeDeletedAndUnpublished: false,
                //CouncilID: councilId,
                //IsCommunityOrganisation: false,
                //IsATDW: false,
                //IsEventFinda: false,
                //IsCheckup: false,
                //IsCATS: false,
                //IsPrivate: false,
                //Latitude: latitude,
                //Longitude: longitude,
                //RadiusKM: searchRadius,
                GeographyID: geographyId,
                DiaryFormatID: diaryFormatID,
                DiaryTypeIDs: diaryTypeIDs,
                //IgnoreEventIds: ignoreEventIds,
                //IgnoreEventKeys: ignoreEventKeys
            },
            beforeSend: function () {
                $('#resultsPanelUCL .waiting').show();
                $("#resultsUCL").show();
                var eventTypeText = '';
                switch (diaryTypeIDs.length) {
                    case 1:
                        switch (diaryTypeIDs[0]) {
                            case 1:
                            case '1':
                                eventTypeText = 'Community Diary';
                                break;
                            case 4:
                            case '4':
                                eventTypeText = 'Clubs & Groups Diary';
                                break;
                            case 5:
                            case '5':
                                eventTypeText = 'Outreach Services Diary';
                                break;
                        }
                        break;
                    case 0:
                    default:
                        break;
                }
                $('#topEventsHeaderUCL .eventType').text(eventTypeText);
                $('#resultsPanelUCL .show-more').hide();
            },
            success: function (events) {
                var data = events.Data;
                if (data && data.length > 0) {
                    var template = $("#resultTemplate").render(data, { DiaryUrl: window.AppSettings.DiaryUrl }).replace(/col-lg-3/g, "col-lg-" + searchDefaults.ResultPanelClass);
                    var $template = $("<div/>").html(template);
                    //$(".nofollow", $template).removeAttr("rel");
                    template = $template.html();

                    $("#resultsUCL").append(template);
                    $("#resultsUCL .card-description").shave(48);

                    $('#resultsPanelUCL .show-more').show();
                    $('#resultsPanelUCL .show-more').off('click').on('click', function () {
                        var newOptions = $.extend({}, options);
                        var currentPage = $(this).data('page');
                        currentPage += 1;
                        newOptions.PAGE_NO = currentPage;
                        $(this).data('page', currentPage);
                        GetGeographyResults(newOptions, diaryTypeIDs);
                    });
                }
                else
                {
                    $('#resultsPanelUCL .show-more').hide();
                    $("#resultsUCL").append($("<div class='row'><div class='col-xs-offset-1 col-xs-10'><div class='alert alert-info' style='border-width: 0; border-left-width: 5px; border-color: #9cb4c5; color: #305d8c; background-color: #d6dde7;'><i class='fa fa-frown-o'></i> There are no more events found within this area. You may discover more nearby events below!</div></div></div>"));
                    return;
                }
            },
            error: function () {
                $("#resultsUCL").hide();
                $('#resultsPanelUCL').hide();
            },
            complete: function () {
                $('#resultsPanelUCL .waiting').hide();
            }
        });
    }

    function OnClickGetGeographyResults() {
        if ($('#resultsPanelUCL').length > 0) {
            $("#resultsUCL").empty();
            var search = buildSearch(true);
            var configOptions = {
                geographyId: search.GeographyID
            };
            var diaryTypeId = [];
            if (!search.DiaryTypeID || search.DiaryTypeID == '') {
                diaryTypeId = [1, 4, 5];
            } else {
                diaryTypeId = [search.DiaryTypeID];
            }
            var searchOptions = {
                DiaryTypeIDs: diaryTypeId,
                DiaryFormatID: search.DiaryFormatID,
                WhenIndex: search.WhenIndex
            }
            GetGeographyResults(configOptions, searchOptions);
        }
    }

    function getResults() {
        showLoading();
        searchDefaults.CalendarDisplay = false;
        var search = buildSearch(true);

        $.post({
            url: window.AppSettings.ApiUrl + "/api/v1/search/diary/GetUniqueEventGroupings",
            contentType: "application/json",
            data: JSON.stringify(search),
            beforeSend: function () {
                manipulateTopEventHeader();
                $("#resultsPanel .show-more").hide();
            },
            success: function (data) {
                showResults(data);
            },
            error: function(err) {
                console.log(err);
                //$("#results").append("<div class='alert alert-warning'>There was an error retrieving events!</div>");
                searchDefaults.FinishedAutoScroll = true;
                hideLoading();
                $("#resultsPanel .show-more").hide();
            }
        });
    }

    var ariaGrid;
    function showResults(events) {
        $("#results").attr("aria-rowcount", $("#results result-card").length);
        if (events.length > 0 && $("#results").length > 0) {
            events.forEach(function (e) {
                if (e.DataProviderKey && e.DataProviderKey.length > 0) {
                    ignoreEventKeys.push(e.DataProviderKey.split('/')[0]);
                } else {
                    ignoreEventIds.push(e.EventID);
                }
            });
            var template = $("#resultTemplate").render(events, { DiaryUrl: window.AppSettings.DiaryUrl }).replace(/col-lg-3/g, "col-lg-" + searchDefaults.ResultPanelClass);
            var $template = $("<div/>").html(template);
            $(".nofollow", $template).removeAttr("rel");
            template = $template.html();

            $("#results").append(template);
            $(".card-description").shave(48);

            searchDefaults.PageNo++;
            if (events.length >= searchDefaults.PageSize) {
                $("#resultsPanel .show-more").show();
                searchDefaults.FinishedAutoScroll = true;
            } else {
                $("#resultsPanel .show-more").hide();
            }

            // Are we currently focused? Then restore after rebuild
            var isFocused = ariaGrid && ariaGrid.findFocusedItem(document.activeElement);
            var x = 0, y = 0;
            if (isFocused) {
                x = ariaGrid.focusedRow;
                y = ariaGrid.focusedCol;
                // Have to reset tabindex as this is used to build grid - not a perfect approach
                $(document.activeElement).attr("tabindex", "-1");
            }

            ariaGrid = new aria.Grid(document.getElementById("results"));

            if (isFocused) {
                ariaGrid.setFocusPointer(x, y);
            }
        }
        else {
            if (searchDefaults.PageNo === 1) {
                $("#results").append($("<div class='row'><div class='col-xs-offset-1 col-xs-10'><div class='alert alert-info' style='border-width: 0; border-left-width: 5px; border-color: #9cb4c5; color: #305d8c; background-color: #d6dde7;'><i class='fa fa-frown-o'></i> There were no events found that match your query. Consider revising your options and trying again!</div></div></div>"));
            }
            searchDefaults.FinishedAutoScroll = true;
            $("#resultsPanel .show-more").hide();
        }

        hideLoading();
    }

    var searchDefaults = {
        ScrollLoading: true,
        FinishedAutoScroll: false,
        PageNo: 1,
        PageSize: 20,
        ResultPanelClass: "3",
        CouncilID: 0,
        StateCode: null,
        KeyWords: null,
        CalendarDisplay: false,
        BottomMarginTrigger: 250,
        PagesToAutoScroll: 3
    };

    function getCouncilDetails(councilId) {
        $.getJSON(window.AppSettings.ApiUrl + "/api/v1/system/councils/" + councilId, function (data) {
            if (data) {
                displayCouncilDetails(data);
            }
        });
    }

    function displayCouncilDetails(council)
    {
        var template = $("#councilTemplate").render(council);
        var $template = $("<div/>").html(template);
        $(".nofollow", $template).removeAttr("rel");
        template = $template.html();
        $(".council-details").html(template);

        var template2 = $("#councilTrailTemplate").render(council);
        var $template2 = $("<div/>").html(template2);
        $(".nofollow", $template2).removeAttr("rel");
        template2 = $template2.html();
        $(".council-trail").html(template2);
    }

    function showAdvancedFilter() {
        $("#filterPanel").show();
        $(".show-advanced").addClass("active");
    }

    function hideAdvancedFilter() {
        $("#filterPanel").hide();
        $(".show-advanced").removeClass("active");

    }

    function hideEventFormats(url_type_num) {
        switch (url_type_num) {
            case 1:
                displayEventFormats = [1, 2, 3, 4, 5, 6, 7, 8, 9];
                break;
            case 2:
                displayEventFormats = [1, 7];
                break;
            case 3:
                displayEventFormats = [7];
                break;
            case 4:
                displayEventFormats = [1, 2, 3, 6, 8, 9];
                break;
            case 5:
                displayEventFormats = [10, 11, 12, 13, 14];
                break;
            default:
                displayEventFormats = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        }

        var totalEventFormats = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
        var hiddenArray = totalEventFormats.filter(function (val) { return displayEventFormats.indexOf(val) == -1 });
        totalEventFormats.forEach(function (e) { $("[data-format='" + e + "']").show(); });
        hiddenArray.forEach(function (e) { $("[data-format='" + e + "']").hide(); });
    }

    function manipulateTopEventHeader() {
        $("#topEventsHeader").empty();

        var DiaryTypeId = isNaN(parseInt($("#DiaryType").val())) ? 0 : parseInt($("#DiaryType").val());
        var EventFormatId = isNaN(parseInt($("#DiaryFormat").val())) ? 0 : parseInt($("#DiaryFormat").val());
        var eventTypeMapForHeader = {
            0: 'All',
            1: 'Community Diary',
            2: 'Training Diary',
            3: 'Inter-Agency Diary',
            4: 'Clubs & Groups Diary',
            5: 'Outreach Services Diary',
            7: 'Queensland Mental Health Week'
        };
        var eventFormatMapForHeader = {
            0: 'All',
            1: 'Class',
            2: 'Exhibition',
            3: 'Festival',
            4: 'Market',
            5: 'Concert',
            6: 'Sport',
            7: 'Business',
            8: 'Community',
            9: 'Food',
            10: 'Vaks',
            11: 'Health',
            12: 'Transport Hub',
            13: 'Covid Vaccination Clinic',
            14: 'Covid Testing Clinic'
        };
        var DiaryType = eventTypeMapForHeader[DiaryTypeId];
        var EventFormat = eventFormatMapForHeader[EventFormatId];
        var displayPeriod = "";
        switch ($("#WhenIndex").val()) {
            case "Today":
                displayPeriod = " - Today";
                break;
            case "Tomorrow":
                displayPeriod = " - Tomorrow";
                break;
            case "Next7":
                displayPeriod = " - Coming Week";
                break;
            default:
                displayPeriod = useDefaultSearchPeriod && $("#WhenIndex").val() == "All" ? " - Next 30 days" : "";
                break;
        }
        if (EventFormatId != 0) {
            $("#topEventsHeader").append("<h1 class='h3'>What's on " + councilDisplayName + " - Upcoming " + EventFormat + " Events in " + councilDisplayName + displayPeriod + "</h1>")
        } else if (EventFormatId == 0 && DiaryTypeId != 0) {
            $("#topEventsHeader").append("<h1 class='h3'>What's on " + councilDisplayName + " - Upcoming " + DiaryType + " Events in " + councilDisplayName + displayPeriod + "</h1>")
        } else {
            $("#topEventsHeader").append("<h1 class='h3'>What's on " + councilDisplayName + " - Upcoming " + " Events in " + councilDisplayName + displayPeriod + "</h1>")
        }   
    }

    function removeTopEventHeader() {
        $("#topEventsHeader").empty();
    }

    function filterDiaryFormats(selectedArray, sourceObj) {
        return Object.keys(sourceObj)
            .filter(function (key) { return selectedArray.indexOf(Number(key)) > -1; })
            .reduce(function(obj, key) {
                obj[key] = sourceObj[key];
                return obj;
            }, {});
    }

    function SearchTaggedEvents() {
        var search = buildSearch(true);
        var specialEventPeriods = [];
        $('.event-period').each(function () {
            var eventPeriodTagIds = [];
            var eventPeriodId = $(this).data("event-period-id");
            var eventPeriodTagId = $(this).data("event-period-tag-id");
            if (eventPeriodTagId && eventPeriodTagId.toString().length > 0) {
                var tags = eventPeriodTagId.toString().split(',');
                eventPeriodTagIds = tags.map(function (tag) {
                    return parseInt(tag, 10)
                }).filter(function (tag) {
                    return !isNaN(tag);
                });
            }
            specialEventPeriods.push({ period: eventPeriodId, tags: eventPeriodTagIds });
        });

        // Send request for each special event period
        specialEventPeriods.forEach(function (eventPeriod) {
            search.CustomTagIDs = eventPeriod.tags;

            $.post({
                url: window.AppSettings.ApiUrl + "/api/v1/search/diary/GetUniqueEventGroupings",
                contentType: "application/json",
                data: JSON.stringify(search),
                beforeSend: function () {
                    var periodSelector = ".event-period[data-event-period-id=" + eventPeriod.period + "]";
                    $(periodSelector).find('.waiting').show();
                },
                success: function (data) {
                    if (data && data.length > 0) {
                        var template = $("#resultTemplate")
                            .render(data, { DiaryUrl: window.AppSettings.DiaryUrl })
                            .replace(/col-lg-3/g, "col-lg-" + searchDefaults.ResultPanelClass);

                        var $template = $("<div/>").html(template);
                        template = $template.html();

                        // Append the results to the corresponding event period
                        var resultsSelector = ".event-period-results[data-event-period-id=" + eventPeriod.period + "]";
                        $(resultsSelector).append(template);
                        $(".card-description").shave(48);
                    }
                },
                error: function (err) {
                    console.error("Error loading data for event period:", eventPeriod.period, err);
                },
                complete: function () {
                    // Hide the waiting spinner for the current event period
                    var periodSelector = ".event-period[data-event-period-id=" + eventPeriod.period + "]";
                    $(periodSelector).find('.waiting').hide();
                }
            });
        });
    }

    function TaggedEventsSearch() {
        $('#search-results-main').on('show.bs.collapse', function () {
            $('#btn-show-default-search').find('.fa-chevron-down').hide();
            $('#btn-show-default-search').find('.fa-chevron-up').show();
        });

        $('#search-results-main').on('hide.bs.collapse', function () {
            $('#btn-show-default-search').find('.fa-chevron-up').hide();
            $('#btn-show-default-search').find('.fa-chevron-down').show();
        });
        $('#btn-show-default-search').on('click', function () {
            $('#search-results-main').collapse('toggle');
        });

        SearchTaggedEvents();
    }

    return {

        InitSearch: function (council, state, search) {
            populateSearch(search);

            $.extend(searchDefaults, search);

            if (council) {
                displayCouncilDetails(council);
            }
            else {
                if (state) {
                    displayCouncilDetails({ DisplayName: state.Name, State: state });
                }
            }

            if (council != null) {
                councilDisplayName = council.DisplayName;
            } else {
                if (state != null) {
                    councilDisplayName = state.Name;
                }
            }

            // set default Diary to CommunityDiary
            var defaultDiaryType = (search.DiaryTypeID == null || search.DiaryTypeID == 0) ? 1 : search.DiaryTypeID;

            // hide eventFormats according to different Diary type
            hideEventFormats(defaultDiaryType);

            // instead of getResult() with the old configuration
            // getResults();
            // we get the first event type which has some events and show results according to that type
            // find event type with some events
            var typeValues = [];
            $('#eventTypeButtons button').each(function () {
                var dataType = $(this).data('type');
                typeValues.push(dataType);
            });
            typeValues.sort();

            if ($('#isTaggedEventsPage').val() === "True") {
                TaggedEventsSearch();
            } else {
                $('#special-event-banner').slick({
                    slidesToShow: 1,
                    slide: "div",
                    autoplay: true,
                });
                $('#special-event-banner').removeClass('hidden');
                $('#special-event-banner').addClass('flex-important');

                $.get(window.AppSettings.ApiUrl + '/api/v1/search/diary/GetEventTypesWithCount',
                    {
                        WhatText: search.WhatText,
                        WhenIndex: 'All',
                        SearchFrom: createDateTime($("#SearchFrom").val(), 23, 59, 59, 999),
                        SearchTo: createDateTime($("#SearchTo").val(), 23, 59, 59, 999),
                        UniqueEvents: true,
                        IncludeExpiredEvents: false,
                        CouncilID: search.CouncilID,
                        DiaryTypeIds: typeValues,
                        StateCode: search.StateCode
                    })
                    .done(function (res) {
                        if (res && res.length > 0) {
                            res.sort();
                            if ($("#eventTypeButtons").find('.btn-primary[data-type]').length <= 0) {
                                if (res.length !== 3) { // if not all types have some results, we use the first type
                                    $("#eventTypeButtons").find('[data-type="' + res[0] + '"]').click();
                                    return;
                                }
                            }
                        } else {
                            $("#DiaryType").val('0').change();
                        }
                        useDefaultSearchPeriod = true; // WhenIndex:All
                        hideEventFormats(0);
                        getResults();
                        OnClickGetGeographyResults();
                    })
                    .fail(function (err) {
                        useDefaultSearchPeriod = true; // WhenIndex:All
                        hideEventFormats(0);
                        getResults();
                        OnClickGetGeographyResults();
                        console.log(err);
                    });

                $(".filter-events").on("click", function (e) {
                    e.preventDefault();
                    var period = $(this).data("period");
                    $("#WhenIndex").val(period);
                    searchDefaults.PageNo = 1;
                    searchDefaults.FinishedAutoScroll = false;
                    $("#resultsPanel .show-more").hide();
                    $("#results").html("");

                    // Important!
                    ignoreEventIds = [];
                    ignoreEventKeys = [];

                    getResults();
                    OnClickGetGeographyResults();
                });

                $("#eventTypeButtons").on("click", ".search-icon-btn", function () {
                    $(this).toggleClass("btn-primary btn-mcd-orange");

                    // Important!
                    ignoreEventIds = [];
                    ignoreEventKeys = [];

                    $('#WhenIndex').val('All').change();

                    if (!$(this).hasClass("btn-primary")) {
                        $("#eventTypeButtons .search-icon-btn").removeClass("btn-primary").removeClass("btn-mcd-orange").addClass("btn-secondary");
                        $("#DiaryType").val("0");
                    }
                    else {
                        $("#eventTypeButtons .search-icon-btn").removeClass("btn-primary").removeClass("btn-mcd-orange").addClass("btn-secondary");
                        $(this).removeClass("btn-secondary").addClass("btn-primary").addClass("btn-mcd-orange");
                        $("#DiaryType").val($(this).data("type"));
                    }

                    // when clicking a new DiaryType, all event formats are unselected
                    if ($(this).hasClass("btn-primary")) {
                        $("#eventFormatButtons .search-icon-btn").removeClass("btn-primary").removeClass("btn-mcd-orange").addClass("btn-secondary");
                        $("#DiaryFormat").val('');
                    }

                    searchDefaults.PageNo = 1;
                    searchDefaults.FinishedAutoScroll = false;
                    $("#resultsPanel .show-more").hide();
                    $("#results").html("");

                    url_type = parseInt($("#DiaryType").val());
                    url_type = (url_type == null || isNaN(url_type)) ? 0 : url_type;

                    url_format = parseInt($("#DiaryFormat").val());
                    url_format = (url_format == null || isNaN(url_format)) ? 0 : url_format;

                    var url = "";
                    if (state != null) {
                        var hostName = window.location.origin;
                        var stateName = state.LongUrl;
                        var regionName = (council != null) ? council.DisplayName.replace(" ", "_") : "";

                        url = (council != null) ? hostName + "/" + stateName + "/" + regionName : hostName + "/" + stateName;

                        var urlParam_type = eventTypeMap[url_type];
                        var urlParam_format = eventFormatMap[url_format];
                        urlParam_type = (urlParam_type == null) ? "All" : urlParam_type;
                        urlParam_format = (urlParam_format == null) ? "All" : urlParam_format;

                        var councilName = (council != null) ? council.DisplayName : state.Name;
                        switch (url_type) {
                            case 1:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = "What's On " + councilName + " | " + councilName + " Community Diary | Events in " + councilName;
                                metaTagDescription = "Looking for something to do in " + councilName + "?  The " + councilName + " Community Diary provides up-to-date information for community organisations who provide Community Diary events in the " + councilName + " area.";
                                metaTagKeywords = "Community Diary - Classes | Exhibitions | Festivals | Markets | Concerts | Sporting | Business | Community | Food events in | What's on | Events in " + councilName;
                                sidebarDiaryType = "Community Diary";
                                break;
                            case 2:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = councilName + " Training Diary | Find What's On and what to Do.";
                                metaTagDescription = "Looking for training in " + councilName + "?  The " + councilName + " Training provides up-to-date information for community organisations who provide Training events in the " + councilName + " area.";
                                metaTagKeywords = "Training Diary - Classes and Business events in " + councilName;
                                sidebarDiaryType = "Training Diary";
                                break;
                            case 3:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = councilName + " Inter-Agency Diary | Find What's On and what to Do.";
                                metaTagDescription = "Looking for Inter-Agencies or Networks in " + councilName + "?  The " + councilName + " Inter-Agency provides up-to-date information for community organisations who run interagency or network events in the " + councilName + " area.";
                                metaTagKeywords = "Inter-Agency Diary - Business events in " + councilName;
                                sidebarDiaryType = "Inter-Agency Diary";
                                break;
                            case 4:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = councilName + " Clubs & Groups Diary | Find What's On and what to Do.";
                                metaTagDescription = "Looking to get involved with a club or group in " + councilName + "?  The " + councilName + " Clubs&Groups provides up-to-date information for club and group events in the " + councilName + " area.";
                                metaTagKeywords = "Clubs & Groups Diary - Classes | Exhibitions | Festivals | Sporting | Community | Food events in " + councilName;
                                sidebarDiaryType = "Clubs & Groups Diary";
                                break;
                            case 5:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = councilName + " Outreach & Visiting Service Diary | Find What's On and what to Do.";
                                metaTagDescription = "Looking for outreach and visiting services in " + councilName + "?  The " + councilName + " Outreach Service (Services) is the one place to find health and welfare services and appointments in the " + councilName + " area.";
                                metaTagKeywords = "Outreach & Visiting Services Diary - Food Vans and Kitchens Services | VAKS, Health, Transport Routes, Covid Clinics & Vaccination | Vax events in " + councilName;
                                sidebarDiaryType = "Outreach & Services Diary";
                                break;
                            case 7:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = councilName + " Queensland Mental Health Week | Find What's On and what to Do.";
                                metaTagDescription = "Looking for something to do in " + councilName + "?  The " + councilName + " Queensland Mental Health Week provides up-to-date information for community organisations who provide events in the " + councilName + " area.";
                                metaTagKeywords = "Queensland Mental Health Week - Classes | Exhibitions | Festivals | Markets | Concerts | Sporting | Business | Community | Food events in " + councilName;
                                sidebarDiaryType = "Queensland Mental Health Week";
                                break;
                            default:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagTitle = councilName + " Community Diary | Find What's On and what to Do.";
                                metaTagDescription = "Looking for something to do in " + councilName + "?  The " + councilName + " Community Diary provides up-to-date information for community organisations who provide events in the " + councilName + " area.";
                                metaTagKeywords = "Community Diary - Classes | Exhibitions | Festivals | Markets | Concerts | Sporting | Business | Community | Food events in " + councilName;
                                sidebarDiaryType = "Community Diary";
                        }

                        // change tile, meta description and meta keywords
                        metaTitle = '<title>' + metaTagTitle + '</title>';
                        metaDescription = '<meta name="description" content="' + metaTagDescription + '">';
                        metaKeywords = '<meta name="keywords" content="' + metaTagKeywords + '">';

                        $('title').remove();
                        $('head').append(metaTitle);
                        $('meta[name=description]').remove();
                        $('head').append(metaDescription);
                        $('meta[name=keywords]').remove();
                        $('head').append(metaKeywords);
                        $('#sidebardiarytype').text(sidebarDiaryType);

                    } else {
                        var hostName = window.location.origin;
                        url = hostName + "/Search/Results";
                        var urlParam_type = eventTypeMap[url_type];
                        var urlParam_format = eventFormatMap[url_format];
                        urlParam_type = (urlParam_type == null) ? "All" : urlParam_type;
                        urlParam_format = (urlParam_format == null) ? "All" : urlParam_format;
                        url += "/" + urlParam_type + "/" + urlParam_format;
                    }

                    // change url
                    window.history.replaceState(null, null, url);

                    useDefaultSearchPeriod = true; // WhenIndex:All
                    getResults();
                    OnClickGetGeographyResults();

                    // hide event formats
                    hideEventFormats(url_type);

                });

                $("#eventTypeButtons").on("change", ".search-icon-btn", function () {
                    $(this).toggleClass("btn-primary btn-mcd-orange");
                });

                $("#eventFormatButtons").on("click", ".search-icon-btn", function () {

                    // Important!
                    ignoreEventIds = [];
                    ignoreEventKeys = [];

                    $(this).toggleClass("btn-mcd-orange");

                    if (!$(this).hasClass("btn-mcd-orange")) {
                        $("#eventFormatButtons .search-icon-btn").removeClass("btn-primary").removeClass("btn-mcd-orange").addClass("btn-secondary");
                        $("#DiaryFormat").val('');
                    }
                    else {
                        $("#eventFormatButtons .search-icon-btn").removeClass("btn-primary").removeClass("btn-mcd-orange").addClass("btn-secondary");
                        $(this).removeClass("btn-secondary").addClass("btn-primary").addClass("btn-mcd-orange");
                        $("#DiaryFormat").val($(this).data("format"));

                    }
                    searchDefaults.PageNo = 1;
                    searchDefaults.FinishedAutoScroll = false;
                    $("#resultsPanel .show-more").hide();
                    $("#results").html("");

                    url_type = parseInt($("#DiaryType").val());
                    url_type = (url_type == null) ? 0 : url_type;

                    url_format = parseInt($("#DiaryFormat").val());
                    url_format = (url_format == null || isNaN(url_format)) ? 0 : url_format;

                    var url = "";

                    if (state != null) {
                        var hostName = window.location.origin;
                        var stateName = state.Name.replace(/\ /g, '_');
                        var regionName = (council != null) ? council.DisplayName.replace(/\ /g, '_') : "";
                        url = (council != null) ? hostName + "/" + stateName + "/" + regionName : hostName + "/" + stateName;

                        var urlParam_type = eventTypeMap[url_type];
                        var urlParam_format = eventFormatMap[url_format];
                        urlParam_type = (urlParam_type == null) ? "All" : urlParam_type;
                        urlParam_format = (urlParam_format == null) ? "All" : urlParam_format;

                        var councilName = (council != null) ? council.DisplayName : state.Name;
                        var metaKeywords;
                        var metaTagKeywords = "Community Diary - Exhibitions | Festivals | Markets | Concerts | Sporting | Business | Community | Food events in " + councilName;

                        switch (url_format) {
                            case 0:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Exhibitions | Festivals | Markets | Concerts | Sporting | Business | Community | Food events in " + councilName;
                                        break;
                                    case 2:
                                        metaTagKeywords = "Training Diary - Classes and Business events in " + councilName;
                                        break;
                                    case 3:
                                        metaTagKeywords = "Inter-Agency Diary - Business events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Classes | Exhibitions | Festivals | Sporting | Community | Food events in " + councilName;
                                        break;
                                    case 5:
                                        metaTagKeywords = "Outreach and Visiting Services Diary - Food Vans and Kitchens Services | VAKS, Health, Transport Routes, Covid Clinics & Vaccination | Vax events in " + councilName;
                                        break;
                                }
                                break;
                            case 1:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 2:
                                        metaTagKeywords = "Training Diary - Classes events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Classes events in " + councilName;
                                        break;
                                }
                                break;
                            case 2:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Exhibition events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Exhibition events in " + councilName;
                                        break;
                                }
                                break;
                            case 3:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Festival events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Festival events in " + councilName;
                                        break;
                                }
                                break;
                            case 4:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Market events in " + councilName;
                                        break;
                                }
                                break;
                            case 5:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Concert events in " + councilName;
                                        break;
                                }
                                break;
                            case 6:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Sport events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Sport events in " + councilName;
                                        break;
                                }
                                break;
                            case 7:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Business events in " + councilName;
                                        break;
                                    case 2:
                                        metaTagKeywords = "Training Diary - Business events in " + councilName;
                                        break;
                                    case 3:
                                        metaTagKeywords = "Inter-Agency Diary - Business events in " + councilName;
                                        break;
                                }
                                break;
                            case 8:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Community events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Community events in " + councilName;
                                        break;
                                }
                                break;
                            case 9:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                switch (url_type) {
                                    case 1:
                                        metaTagKeywords = "Community Diary - Food events in " + councilName;
                                        break;
                                    case 4:
                                        metaTagKeywords = "Clubs and Groups Diary - Food events in " + councilName;
                                        break;
                                }
                                break;
                            case 10:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagKeywords = "Outreach and Visiting Service Diary - Vaks events in " + councilName;
                                break;
                            case 11:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagKeywords = "Outreach and Visiting Service Diary - Health events in " + councilName;
                                break;
                            case 12:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagKeywords = "Outreach and Visiting Service Diary - Transport Hub events in " + councilName;
                                break;
                            case 13:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagKeywords = "Outreach and Visiting Service Diary - COVID Vaccination Clinic events in " + councilName;
                                break;
                            case 14:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagKeywords = "Outreach and Visiting Service Diary - COVID Testing Clinic events in " + councilName;
                                break;
                            default:
                                url += "/" + urlParam_type + "/" + urlParam_format;
                                metaTagKeywords = "Community Diary - Exhibitions | Festivals | Markets | Concerts | Sporting | Business | Community | Food events in " + councilName;
                        }

                        metaKeywords = '<meta name="keywords" content="' + metaTagKeywords + '">';
                        $('meta[name=keywords]').remove();
                        $('head').append(metaKeywords);

                    }
                    else {
                        var hostName = window.location.origin;
                        url = hostName + "/Search/Results";
                        var urlParam_type = eventTypeMap[url_type];
                        var urlParam_format = eventFormatMap[url_format];
                        urlParam_type = (urlParam_type == null) ? "All" : urlParam_type;
                        urlParam_format = (urlParam_format == null) ? "All" : urlParam_format;
                        url += "/" + urlParam_type + "/" + urlParam_format;
                    }
                    window.history.replaceState(null, null, url);

                    getResults();
                    OnClickGetGeographyResults();

                    if ($("#calendar").is(':visible')) {
                        $('#calendar').fullCalendar('removeEvents');
                        $('#calendar').fullCalendar('refetchEvents');
                    }
                });
            }
            //

            var windowWidth = $(window).width();
            if (windowWidth < 400) {
                $('.coming-week').text('Week');
            }

            //$(window).scroll(function () {
            //    if (!searchDefaults.FinishedAutoScroll && !searchDefaults.ScrollLoading) {
            //        if ($(window).scrollTop() >= $(document).height() - $(window).height() - searchDefaults.BottomMarginTrigger) {
            //            getResults();
            //        }
            //    }
            //});

            $(".show-advanced").on("click", function (e) {
                if ($(this).hasClass("active")) {
                    hideAdvancedFilter();
                }
                else {
                    showAdvancedFilter();
                }
            });

            $(".hide-advanced").on("click", function (e) {
                hideAdvancedFilter();
            });

            $(".btn-search").on("click", function (e) {
                e.preventDefault();

                // Important!
                ignoreEventIds = [];
                ignoreEventKeys = [];

                if (searchDefaults.CalendarDisplay) {
                    $("#calendar").fullCalendar("refetchEvents");
                }
                else {
                    searchDefaults.PageNo = 1;
                    searchDefaults.FinishedAutoScroll = false;
                    $("#resultsPanel .show-more").hide();
                    $("#results").html("");
                    getResults();
                }
            });

            $("#resultsPanel .show-more").on("click", function (e) {
                e.preventDefault();
                getResults();
            });
            $("#resultsUCLPanel .show-more").on("click", OnClickGetGeographyResults);

            $("#viewCalendar").on("click", function (l) {
                l.preventDefault();
                useDefaultSearchPeriod = false;
                $("#topEventsHeader").empty();
                $("#topEventsHeader").append("<h1 class='h3'>What's on " + councilDisplayName + " - Upcoming " + " Events in " + councilDisplayName + "</h1>")

                hideLoading();
                $(".grid-only").hide();
                $("#resultsPanel .show-more").hide();
                $("#results").hide();

                $("#resultsUCL").hide();
                $("#resultsPanelUCL").hide();
                $("#topEventsHeaderUCL").hide();

                $("#calendar").show();
                $(this).addClass("active");
                $("#viewList").removeClass("active");
                $("#calendar").fullCalendar({
                    header: {
                        left: "prev,next today",
                        center: "title",
                        right: "month,agendaWeek,agendaDay"
                    },
                    height: "auto",
                    startParam: "SearchFrom",
                    endParam: "SearchTo",
                    nowIndicator: true,
                    fixedWeekCount: false,
                    events: {
                        url: window.AppSettings.ApiUrl + "/api/v1/search/diary/GetInstanceResults",
                        data: function () {
                            searchDefaults.CalendarDisplay = true;
                            return buildSearch(false);
                        }
                    },
                    eventDataTransform: function (event) {
                        var eventDisplayColour = "#DCDCDC";
                        switch (event.DiaryTypeID) {
                            case 1:
                                eventDisplayColour = "#4169E1";
                                break;
                            case 2:
                                eventDisplayColour = "#D2691E";
                                break;
                            case 3:
                                eventDisplayColour = "#2E8B57";
                                break;
                            case 4:
                                eventDisplayColour = "#BA55D3";
                                break;
                        }
                        return {
                            id: event.ID,
                            title: event.EventName,
                            start: event.StartsAt,
                            end: event.EndsAt,
                            url: event.InstanceUrl,
                            allDay: "All Day" === event.StartTime,
                            diaryElement: event,
                            color: eventDisplayColour
                        };
                    },
                    eventRender: function (event, element) {
                        var template = $("#resultTemplate").render(event.diaryElement, { DiaryUrl: window.AppSettings.DiaryUrl }).replace("col-xs-12 col-sm-6 col-md-4 col-lg-3", "result-card-tip");
                        var $template = $("<div/>").html(template);
                        $(".nofollow", $template).removeAttr("rel");
                        template = $template.html();
                        element.qtip({
                            content: template,
                            position: {
                                target: "mouse",
                                adjust: { x: -5, y: -5 },
                                my: "bottom right",
                                at: "top left"
                            },
                            style: "qtip-light qtip-rounded",
                            events: {
                                show: function (event, api) {
                                    var t = $(".card-description", $(this));
                                    t.html(truncateString(t.html(), 160));
                                }
                            }
                        });
                    },
                    loading: function (isLoading, view) {
                        if (isLoading) {
                            $("#spinner").show();
                        }
                        else {
                            $("#spinner").hide();
                        }
                    }
                });
            });

            $("#viewList").on("click", function (e) {
                e.preventDefault();
                $(this).addClass("active");
                $("#viewCalendar").removeClass("active");
                $("#calendar").hide();

                // Important!
                ignoreEventIds = [];
                ignoreEventKeys = [];

                searchDefaults.PageNo = 1;
                searchDefaults.FinishedAutoScroll = false;
                $(".grid-only").show();
                $("#resultsPanel .show-more").hide();
                $("#results").html("");
                $("#results").show();

                $("#resultsUCL").show();
                $("#resultsPanelUCL").show();
                $("#topEventsHeaderUCL").show();

                getResults();
                OnClickGetGeographyResults();
            });

            if ($("#WhenIndex").val() !== "Custom") {
                $(".custom-date").hide();
            }
            $("#WhenIndex").on("change", function () {
                if ($(this).val() === 'Custom') {  // Custom
                    $(".custom-date").show();
                }
                else {
                    $(".custom-date").hide();
                }
            });

            $("#DiaryType").on("change", function () {
                var filteredDiaryFormats = {};
                var DiaryTypeSelected = $('#DiaryType').val();
                switch (DiaryTypeSelected) {
                    case "1":
                        // community diary
                        var selectedArray = [1, 2, 3, 4, 5, 6, 7, 8, 9]
                        break;
                    case "2":
                        // training
                        var selectedArray = [1, 7]
                        break;
                    case "3":
                        // inter-agency
                        var selectedArray = [7]
                        break;
                    case "4":
                        // clubs & groups
                        var selectedArray = [1, 2, 3, 6, 8, 9]
                        break;
                    case "5":
                        // outreach & services
                        var selectedArray = [10, 11, 12, 13, 14]
                        break;
                    default:
                        // other diary type
                        var selectedArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]
                        break;
                }

                filteredDiaryFormats = filterDiaryFormats(selectedArray, DiaryFormatsDisplayName);
                var $select = $('#DiaryFormat');
                $select.find("option").remove();
                $.each(filteredDiaryFormats, function (key, value) {
                    $select.append("<option value=\"" + key + "\">" + value + "</option>");
                });
            });

            // If the user clears the where field, clear the location id 
            $("#SearchCriteria_WhereText").on("change", function () {
                if (!$(this).val()) {
                    $("#SearchCriteria_LocationID").val('');
                }
            });

            //btn preselected
            var evnt = $("#DiaryType").val() ? $("#DiaryType").val():0;
            var format = $("#DiaryFormat").val() ? $("#DiaryFormat").val():0;
            var url_type = $("#DiaryType").val() ? $("#DiaryType").val() : 0;
            var url_format = $("#DiaryFormat").val() ? $("#DiaryFormat").val() : 0;

            $("[data-type='" + evnt + "']").addClass("btn-primary").addClass("btn-mcd-orange");
            $("[data-format='" + format + "']").addClass("btn-primary").addClass("btn-mcd-orange");

            //if (!search.StateCode) {
            //    window.history.replaceState(null, null, "/Search/Results/" + eventTypeMap[evnt] + "/" + eventFormatMap[format]);
            //}
         
            $("#Clear").on("click", function () {
                $("#eventTypeButtons .search-icon-btn").removeClass("btn-primary").addClass("btn-secondary");
                $("#eventFormatButtons .search-icon-btn").removeClass("btn-primary").addClass("btn-secondary");
                $("#DiaryType").val('');
                $("#DiaryFormat").val('');
                $("#DiaryAudience").val('');
                $("#KeyWords").val('');
                $("#WhenIndex").val('All');
                searchDefaults.PageNo = 1;
                searchDefaults.FinishedAutoScroll = false;
                $("#resultsPanel .show-more").hide();
                $("#results").html("");
                getResults();
            });

            $("#btnFindCouncil").on("click", function () {
                var whatText = $("#SearchCriteria_WhatText").val();
                var whereText = $("#SearchCriteria_WhereText").val().replace(/\s+/g, "_"); // Replace all spaces with underscores

                var path = window.location.origin + window.location.pathname;
                var params = [];

                // Check if 'whatText' is not empty and add to parameters
                if (whatText.trim() !== "") {
                    params.push("what=" + encodeURIComponent(whatText));
                }

                // Check if 'whereText' is not empty and add to parameters
                if (whereText.trim() !== "") {
                    params.push("where=" + encodeURIComponent(whereText));
                }

                // Join parameters with '&' and append to the base URL
                if (params.length > 0) {
                    path += "?" + params.join("&");
                }

                window.location.href = path;
            });
        }
    };
}();
